import { render } from "./CourseFiles.vue?vue&type=template&id=1b6ba80b&scoped=true"
import script from "./CourseFiles.vue?vue&type=script&lang=js"
export * from "./CourseFiles.vue?vue&type=script&lang=js"

import "./CourseFiles.vue?vue&type=style&index=0&id=1b6ba80b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6ba80b"]])

export default __exports__